import { useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useChatNotifications } from "@/hooks/useChatNotifications";

/**
 * Global component that listens for chat messages and shows push notifications
 * when the user is not actively viewing the chat page.
 * 
 * This component should be placed high in the component tree (e.g., in App.tsx)
 * so it runs regardless of which page the user is on.
 */
const ChatNotificationProvider = () => {
  const { user } = useAuth();
  const { requestPermission } = useChatNotifications(user?.id);

  // Request notification permission when user logs in
  useEffect(() => {
    if (user) {
      requestPermission();
    }
  }, [user, requestPermission]);

  // This component doesn't render anything
  return null;
};

export default ChatNotificationProvider;
